import { api } from "./axios";

import type {
  ConvertVisitorToMemberPayload,
  CreateVisitorPayload,
  VisitorAttendance,
  VisitorConversionResponse,
  VisitorRosterResponse,
  VisitorSearchResult,
} from "@/types/visitor";

export async function searchVisitors(
  churchId: string,
  query: string,
  serviceOccurrenceId?: string
): Promise<VisitorSearchResult[]> {
  const response = await api.get<
    VisitorSearchResult[]
  >(
    `/api/churches/${churchId}/visitors/search`,
    {
      params: {
        q: query,
        service_occurrence_id:
          serviceOccurrenceId,
      },
    }
  );

  return response.data;
}

export async function getServiceVisitors(
  churchId: string,
  serviceOccurrenceId: string
): Promise<VisitorRosterResponse> {
  const response =
    await api.get<VisitorRosterResponse>(
      `/api/churches/${churchId}/service-occurrences/${serviceOccurrenceId}/visitors`
    );

  return response.data;
}

export async function createAndCheckInVisitor(
  churchId: string,
  serviceOccurrenceId: string,
  payload: CreateVisitorPayload
): Promise<VisitorAttendance> {
  const response =
    await api.post<VisitorAttendance>(
      `/api/churches/${churchId}/service-occurrences/${serviceOccurrenceId}/visitors`,
      payload
    );

  return response.data;
}

export async function checkInExistingVisitor(
  churchId: string,
  serviceOccurrenceId: string,
  visitorId: string
): Promise<VisitorAttendance> {
  const response =
    await api.post<VisitorAttendance>(
      `/api/churches/${churchId}/service-occurrences/${serviceOccurrenceId}/visitors/${visitorId}/check-in`,
      {
        notes: null,
      }
    );

  return response.data;
}

export async function removeVisitorCheckIn(
  churchId: string,
  serviceOccurrenceId: string,
  visitorId: string
): Promise<void> {
  await api.delete(
    `/api/churches/${churchId}/service-occurrences/${serviceOccurrenceId}/visitors/${visitorId}/check-in`
  );
}

export async function convertVisitorToMember(
  churchId: string,
  visitorId: string,
  payload: ConvertVisitorToMemberPayload
): Promise<VisitorConversionResponse> {
  const response =
    await api.post<VisitorConversionResponse>(
      `/api/churches/${churchId}/visitors/${visitorId}/convert-to-member`,
      payload
    );

  return response.data;
}

export async function classifyVisitor(churchId: string, visitorId: string, classification: "REGULAR" | "YOUTH") {
  await api.patch(`/api/churches/${churchId}/visitors/${visitorId}/classification`, { attendance_classification: classification });
}
